import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import packageJson from '../../package.json';

import GeneralSettings from '../Components/SectionsForSettings/GeneralSettings';
import ControlPanel from '../Components/SectionsForSettings/ControlPanel';
import InformationMessage from '../Components/SectionsForSettings/InformationMessage';
import DataControls from '../Components/SectionsForSettings/DataControls';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';
import stylesSettings from '../styles/Settings.module.css'

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

export const Settings = ({ closeModal }) => {
    const [section, setSection] = React.useState('main');

    const [userId, setUserId] = React.useState('');
    const [userRole, setUserRole] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
        const decodedToken = jwtDecode(token);
        setUserId(decodedToken.id);
        setUserRole(decodedToken.role);
        }
    }, []);


    if (!userId || !userRole) {
        return <></>;
    }

    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={stylesSettings.main}>
                    <div className={stylesSettings.sectionsMenu}>
                        <div>
                            <IconContainer Icon={XIcon} onClick={() => {window.location.hash = ''; closeModal()}} size = '20' color = 'black' className = '' />
                            <ul>
                                <li onClick={() => setSection('main')} className={section === 'main' ? stylesSettings.active : ''}>
                                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="setting"><path d="M19.9 12.66a1 1 0 0 1 0-1.32l1.28-1.44a1 1 0 0 0 .12-1.17l-2-3.46a1 1 0 0 0-1.07-.48l-1.88.38a1 1 0 0 1-1.15-.66l-.61-1.83a1 1 0 0 0-.95-.68h-4a1 1 0 0 0-1 .68l-.56 1.83a1 1 0 0 1-1.15.66L5 4.79a1 1 0 0 0-1 .48L2 8.73a1 1 0 0 0 .1 1.17l1.27 1.44a1 1 0 0 1 0 1.32L2.1 14.1a1 1 0 0 0-.1 1.17l2 3.46a1 1 0 0 0 1.07.48l1.88-.38a1 1 0 0 1 1.15.66l.61 1.83a1 1 0 0 0 1 .68h4a1 1 0 0 0 .95-.68l.61-1.83a1 1 0 0 1 1.15-.66l1.88.38a1 1 0 0 0 1.07-.48l2-3.46a1 1 0 0 0-.12-1.17ZM18.41 14l.8.9-1.28 2.22-1.18-.24a3 3 0 0 0-3.45 2L12.92 20h-2.56L10 18.86a3 3 0 0 0-3.45-2l-1.18.24-1.3-2.21.8-.9a3 3 0 0 0 0-4l-.8-.9 1.28-2.2 1.18.24a3 3 0 0 0 3.45-2L10.36 4h2.56l.38 1.14a3 3 0 0 0 3.45 2l1.18-.24 1.28 2.22-.8.9a3 3 0 0 0 0 3.98Zm-6.77-6a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"></path></svg>
                                    Общие настройки
                                </li>
                                {userRole=='АппаратСРО' &&
                                <>
                                    <li onClick={() => setSection('control-panel')} className={section === 'control-panel' ? stylesSettings.active : ''}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#000000" viewBox="0 0 256 256"><path d="M208,136H48a20,20,0,0,0-20,20v36a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V156A20,20,0,0,0,208,136Zm-4,52H52V160H204Zm4-144H48A20,20,0,0,0,28,64v36a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V64A20,20,0,0,0,208,44Zm-4,52H52V68H204Z"></path></svg>
                                        Панель управления
                                    </li>
                                    <li onClick={() => setSection('information-message')} className={section === 'information-message' ? stylesSettings.active : ''}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#000000" id="info-circle"><path d="M12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Zm0-8.5a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0v-3A1,1,0,0,0,12,11.5Zm0-4a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,7.5Z"></path></svg>
                                        Информационное сообщение в системе
                                    </li>
                                </>
                                }
                                <li onClick={() => setSection('data-controls')} className={section === 'data-controls' ? stylesSettings.active : ''}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="database"><path fill="#000000" d="M8,16.5a1,1,0,1,0,1,1A1,1,0,0,0,8,16.5ZM12,2C8,2,4,3.37,4,6V18c0,2.63,4,4,8,4s8-1.37,8-4V6C20,3.37,16,2,12,2Zm6,16c0,.71-2.28,2-6,2s-6-1.29-6-2V14.73A13.16,13.16,0,0,0,12,16a13.16,13.16,0,0,0,6-1.27Zm0-6c0,.71-2.28,2-6,2s-6-1.29-6-2V8.73A13.16,13.16,0,0,0,12,10a13.16,13.16,0,0,0,6-1.27ZM12,8C8.28,8,6,6.71,6,6s2.28-2,6-2,6,1.29,6,2S15.72,8,12,8ZM8,10.5a1,1,0,1,0,1,1A1,1,0,0,0,8,10.5Z"></path></svg>
                                    <a>Элементы управления данными</a>
                                </li>
                            </ul>
                        </div>
                        <div className='description' style={{margin: '0 0 0 10px'}}>Версия: {packageJson.version}</div>
                    </div>
                    <div className={stylesSettings.openSection}>
                        {section == 'main' ? <GeneralSettings userId={userId} userRole={userRole} />
                        : section == 'control-panel' ? <ControlPanel closeModal={closeModal} />
                        : section == 'information-message'? <InformationMessage userRole={userRole} />
                        : section == 'data-controls'? <DataControls />
                        : <a>Выберите вкладку</a>}
                    </div>
                </div>
            </div>
        </div>
    )
}



export default Settings;